export const normalizeUserRole = (role?: string | null): string => (role || '').trim().toLowerCase()

export const isMerchantReadOnlyUserRole = (role?: string | null): boolean => {
  const normalized = normalizeUserRole(role)
  return normalized === 'merchant.user' || normalized === 'merchant_user'
}

export const canManageMerchantPortalUsers = (role?: string | null): boolean => {
  const normalized = normalizeUserRole(role)
  return normalized === 'merchant.admin' || normalized === 'merchant_admin'
}
